const isImageValidSize = (image, maxSize) =>
  Math.ceil(image.length / 1000) <= maxSize;

export { isImageValidSize };
